import { FC } from 'react';
import { GroupBase, OptionProps } from 'react-select';
import cx from 'classnames';
import { getIconByAsset } from '@/helpers';
import { AppImage, Skeleton } from '@/components';

import { PaymentSelectOption } from '../models';

import styles from './SimpleOptionChain.module.sass';

export type OptionChainProps = OptionProps<
  PaymentSelectOption,
  false,
  GroupBase<PaymentSelectOption>
>;

const SimpleOptionChain: FC<OptionChainProps> = (props) => {
  const { innerProps, data } = props;
  const { label, value, discount } = data;

  const isSelected = true;

  const classes = cx(styles.option, {
    'is-selected': isSelected,
  });

  const iconSrc = getIconByAsset(value);

  return (
    <div className={classes} {...innerProps}>
      {value !== 'showMore' && (
        <div className={styles.icon}>
          <AppImage
            src={iconSrc}
            alt={label}
            fallback={<Skeleton className={styles.icon} border="50%" />}
          />
        </div>
      )}
      <div className={styles.info}>
        <div className={styles.label}>{label}</div>
      </div>
      {!!discount && <div className={styles.discount}>-{discount}%</div>}
    </div>
  );
};

export default SimpleOptionChain;
